import { createAction, props } from "@ngrx/store";
import IUserSkill from "@skills-app/models/userSkills";
import IOrgNode from "@skills-app/models/orgNode";

const prefix = "[Search By Skill Or Consultant API Page]";

export const requestFilteredConsultants = createAction(
  `${prefix} Request Filtered Consultants With Current Conditions`,
);

export const requestFilteredConsultantsCSV = createAction(
  `${prefix} Request to generate a csv from current filter`,
  props<{ includeSkills: boolean }>(),
);

export const filterConsultantsSuccess = createAction(
  `${prefix} Filter Consultants Success`,
  props<{ consultants: IUserSkill[] }>(),
);

export const filterConsultantsError = createAction(
  `${prefix} Filter Consultants Error`,
);

export const filteredConsultantsCSVSuccess = createAction(
  `${prefix} CSV Success`,
);

export const filteredConsultantsCSVError = createAction(`${prefix} CSV Error`);

export const requestRoles = createAction(`${prefix} Request Roles`);

export const requestRolesSuccess = createAction(
  `${prefix} Request Roles Success`,
  props<{ roles: string[] }>(),
);

export const requestRolesError = createAction(`${prefix} Request Roles Error`);

export const requestOrgs = createAction(`${prefix} Request Orgs`);

export const requestOrgsForce = createAction(`${prefix} Request Orgs Force`);

export const requestOrgsSuccess = createAction(
  `${prefix} Request Orgs Success`,
  props<{ orgs: IOrgNode[] }>(),
);

export const requestOrgsError = createAction(`${prefix} Request Orgs Error`);

export const requestLocations = createAction(`${prefix} Request Locations`);

export const requestLocationsSuccess = createAction(
  `${prefix} Request Locations Success`,
  props<{ locations: string[] }>(),
);

export const requestLocationsError = createAction(
  `${prefix} Request Locations Error`,
);
